import { Controller } from "@hotwired/stimulus"

// Color preview controller for admin page form
// Updates color preview div in real-time when header color is selected
export default class extends Controller {
  static targets = ["preview", "select"]

  // Update the preview div when color selection changes
  updatePreview(event) {
    const color = event.target.value
    const previewDiv = this.previewTarget

    if (color && color !== '') {
      // Show color preview
      previewDiv.innerHTML = `
        <div class="h-12 rounded-md border border-neutral-300"
             style="background-color: ${this.escapeHtml(color)}"></div>
        <p class="mt-1 text-xs text-neutral-500">Preview of header banner color</p>
      `
    } else {
      // Clear preview when no color selected
      previewDiv.innerHTML = ''
    }
  }

  // Simple HTML escape for security
  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
